/**
 * Kitting cart labels are 4x2 at 300 DPI.
 */

export { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";

import { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";
import { useZplPrintLocation } from "@/lib/zplPrintLocation";

export const KITTING_ZPL_PRINTER_STORAGE_KEY = ZPL_PRINTER_STORAGE_KEYS.kitting;

export function useKittingZplPrinter(): ReturnType<typeof useZplPrintLocation> {
  return useZplPrintLocation({
    storageKey: ZPL_PRINTER_STORAGE_KEYS.kitting,
    labelSize: "4x2",
    dpi: 300,
  });
}
